import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-16 px-4 bg-gray-50" data-id="element-363">
      <div className="max-w-3xl mx-auto" data-id="element-364">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-365">
          <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-8 md:mb-10" data-id="element-366">
            ✨ MEGAPACK MI ESPACIO INTERIOR — 6 Tomos + 6 Bonos
          </h2>

          <div className="bg-white p-5 md:p-8 rounded-2xl shadow-xl border-2 border-dashed border-red-200 mb-8 md:mb-12" data-id="element-367">
            <ul className="text-left space-y-4 md:space-y-6 text-base md:text-lg text-gray-700 max-w-2xl mx-auto font-medium" data-id="element-368">
              <li className="flex items-start gap-3 md:gap-4" data-id="element-369">
                <span className="text-2xl md:text-3xl" data-id="element-370">📘</span>
                <p data-id="element-371">
                  <span className="font-bold text-gray-900" data-id="element-372">
                    Tomo 1 — El Espejo:
                  </span>{' '}
                  Reconocerse y nombrarse emocionalmente. El adolescente aprende
                  a identificar qué siente, por qué lo siente y cómo ponerle
                  nombre.
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4" data-id="element-373">
                <span className="text-2xl md:text-3xl" data-id="element-374">📙</span>
                <p data-id="element-375">
                  <span className="font-bold text-gray-900" data-id="element-376">
                    Tomo 2 — El Volcán:
                  </span>{' '}
                  Identificar el enojo antes de explotar. Herramientas para
                  reconocer las señales del enojo, frenar la reacción impulsiva
                  y canalizar la energía.
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4" data-id="element-377">
                <span className="text-2xl md:text-3xl" data-id="element-378">📗</span>
                <p data-id="element-379">
                  <span className="font-bold text-gray-900" data-id="element-380">
                    Tomo 3 — El Escudo:
                  </span>{' '}
                  Recursos internos de protección emocional. Desarrolla la
                  capacidad de protegerse frente a presión social, bullying y
                  redes sociales.
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4" data-id="element-381">
                <span className="text-2xl md:text-3xl" data-id="element-382">📕</span>
                <p data-id="element-383">
                  <span className="font-bold text-gray-900" data-id="element-384">
                    Tomo 4 — El Timón:
                  </span>{' '}
                  Tomar decisiones con calma y propósito. Aprende a pausar,
                  evaluar opciones y elegir con claridad.
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4" data-id="element-385">
                <span className="text-2xl md:text-3xl" data-id="element-386">📓</span>
                <p data-id="element-387">
                  <span className="font-bold text-gray-900" data-id="element-388">
                    Tomo 5 — El Puente:
                  </span>{' '}
                  Reconstruir vínculos y comunicarse con adultos. Herramientas
                  para que el adolescente aprenda a expresarse y el adulto
                  aprenda a escuchar diferente.
                </p>
              </li>
              <li className="flex items-start gap-3 md:gap-4 bg-yellow-50 p-4 rounded-xl border border-yellow-200" data-id="element-389">
                <span className="text-2xl md:text-3xl" data-id="element-390">📔</span>
                <p data-id="element-391">
                  <span className="font-bold text-gray-900" data-id="element-392">
                    Tomo 6 — El Mapa:
                  </span>{' '}
                  Plan de bienestar emocional personal. El adolescente crea su
                  propio plan de bienestar: rutinas, recursos, personas de
                  confianza y estrategias personalizadas.
                </p>
              </li>
            </ul>
          </div>

          <div className="max-w-md mx-auto" data-id="element-393">
            <CTAButton text="👉 QUIERO MI MEGAPACK AHORA" data-id="element-394" />
          </div>
        </div>
      </div>
    </section>;
}